<template>
  <b-modal class="modal-lightbox" :active.sync="isOpenModal">
    <!-- Carousel images-->
    <template v-if="isCarousel">
      <client-only>
        <!-- Main -->
        <agile ref="main" class="modal-lightbox-main-carousel" :options="options1" :as-nav-for="asNavFor1">
          <div
            v-for="(media, index) in medias"
            :key="index"
            class="slide slide-main-thumbnail"
            :class="`slide--${index}`"
          >
            <img :src="media.url || media.thumbnail" :alt="media.fileName" />
          </div>
        </agile>
        <!-- Thumbnails -->
        <agile ref="thumbnails" class="modal-lightbox-thumbnails-carousel" :options="options2" :as-nav-for="asNavFor2">
          <div
            v-for="(media, index) in medias"
            :key="index"
            class="slide slide-sub-thumbnail"
            :class="`slide--${index}`"
            @click="$refs.thumbnails.goTo(index)"
          >
            <img :src="media.url || media.thumbnail" :alt="media.fileName" />
          </div>
          <template slot="prevButton">
            <b-icon icon="arrow-left"></b-icon>
          </template>
          <template slot="nextButton">
            <b-icon icon="arrow-right"></b-icon>
          </template>
        </agile>
      </client-only>
    </template>
    <!-- Single -->
    <div v-else class="single-media-container">
      <img class="single-media-image" :src="medias.url || medias.thumbnail" />
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalLightBox',
  props: {
    isCarousel: {
      type: Boolean,
      default() {
        return false
      },
    },
    medias: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      isOpenModal: false,
      asNavFor1: [],
      asNavFor2: [],
      options1: {
        dots: false,
        fade: true,
        navButtons: false,
      },
      options2: {
        autoplay: false,
        centerMode: true,
        dots: false,
        navButtons: false,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 5,
            },
          },
          {
            breakpoint: 1000,
            settings: {
              navButtons: true,
            },
          },
        ],
      },
    }
  },
  computed: {},
  beforeMount() {
    if (typeof window !== 'undefined') {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
      })
    }
  },
  mounted() {
    if (this.isCarousel) {
      this.asNavFor1.push(this.$refs.thumbnails)
      this.asNavFor2.push(this.$refs.main)
    }
    this.isOpenModal = true
  },
}
</script>

<style lang="scss">
.modal.modal-lightbox {
  &.is-active > .modal-background {
    display: block;
  }
  .single-media-container {
    text-align: center;
    margin: 0 auto;
    img.single-media-image {
      height: auto;
      width: auto;
      max-width: 650px;
      display: inline-block;
    }
  }
}
</style>
